import { Call } from 'app/models/dto/call.model';

export class GetUserCallHistory {
  static readonly type = '[UserCallHistory] GetUserCallHistory';
  constructor() {}
}

export class UserSpecified {
  static readonly type = '[UserCallHistory] UserSpecified';
  constructor(
    public lenderUserId: number | null,
  ) {}
}

export class FilterSelection {
  static readonly type = '[UserCallHistory] FilterSelection';
  constructor(
    public filter: string,
  ) {}
}

export class SortSelection {
  static readonly type = '[UserCallHistory] SortSelection';
  constructor(
    public sort: string,
  ) {}
}

export class CallSelection {
  static readonly type = '[UserCallHistory] CallSelection';
  constructor(
    public call: Call | null
   ) {}
}

export class LoadMore {
  static readonly type = '[UserCallHistory] LoadMore';
  constructor(
  ) {}
}
